export const railsInterceptorModule = angular
  .module('Q.interceptors.rails-interceptor', [])

  /*
   * Makes changes to the request to help rails.
   */
  .factory('railsInterceptor', function () {
    return {
      request: function (config) {
        if (config.params) {
          angular.forEach(config.params, function (val, name) {
            if (angular.isArray(val) && !/\[\]$/.test(name)) {
              delete config.params[name];
              config.params[name + '[]'] = val;
            }
          });
        }
        return config;
      },
    };
  })

  .config(function ($httpProvider) {
    $httpProvider.interceptors.push('railsInterceptor');
  });
